import Dropdown from 'bootstrap/js/src/dropdown';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Dropdown = Dropdown;
